import React from 'react';
import revLogo from '../../assets/REV_logo.svg';

const SUPPORT_URL = 'https://40bddu.share-na2.hsforms.com/2t-kNBVHeTp-_hgZZKKJlPg';

export const ClerkUnavailablePage: React.FC = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-6">
        <img src={revLogo} alt="REV" className="h-10 w-auto mx-auto mb-8" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">
          Unable to Connect
        </h1>
        <p className="text-gray-600 mb-6">
          We're having trouble connecting to our authentication service.
          This is usually temporary.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors mb-4"
        >
          Try Again
        </button>
        <p className="text-sm text-gray-500">
          If this continues,{' '}
          <a
            href={SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            contact support
          </a>.
        </p>
      </div>
    </div>
  );
};
